import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetUpcomingWebcasts as GetUpcomingWebcastsQuery,
    GetUpcomingWebcastsVariables as GetUpcomingWebcastsQueryVariables,
    Webcast,
} from 'nutshell-graphql-types';

import GET_UPCOMING_WEBCASTS from '../queries/get-upcoming-webcasts.graphql';

export const useGetUpcomingWebcasts = (
    webcastType: string
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    webcasts: Webcast[];
} => {
    const {loading, data, error} = useQuery<
        GetUpcomingWebcastsQuery,
        GetUpcomingWebcastsQueryVariables
    >(GET_UPCOMING_WEBCASTS, {
        variables: {type: webcastType},
    });

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        webcasts: data && data.upcomingWebcasts ? data.upcomingWebcasts : [],
    };
};
